import LTR from "@brand-icons/ploom/package/package-ltr.svg";
import RTL from "@brand-icons/ploom/package/package-rtl.svg";

import { iconFactory } from "../iconFactory";

export const PackageIcon = iconFactory("PackageIcon", LTR, RTL);
